'use strict';

var React = require('react');
var ReactDom = require('react-dom');
var styleHelper = require('../../helper/styleHelper');
var appTypes = require('../../types/appTypes');

/**
 * 形状部件
 */
var ShapeParts = React.createClass({

  buildShapeStyle: function () {
    var shapeStyle = {
      width: '100%',
      height: '100%'
    };
    shapeStyle.borderStyle = this.props.borderVisible ? 'solid' : 'none';
    shapeStyle.borderColor = this.props.borderColor;
    shapeStyle.borderWidth = this.props.thickness;
    shapeStyle.backgroundColor = this.props.color;
    if (this.props.shapeType === appTypes.SHAPE_TYPE.RECTANGLE) {
      // shapeStyle.borderRadius = this.props.thickness + 'px';
    } else if (this.props.shapeType === appTypes.SHAPE_TYPE.ECLIPSE) {
      shapeStyle.borderRadius = '50%';
    }
    shapeStyle.boxSizing = 'border-box';

    return shapeStyle;
  },

  render: function () {
    var divStyle = this.buildShapeStyle();

    return (<div id='avater oktest' style={divStyle}>
      {this.props.children}
    </div>);
  },
});

module.exports = ShapeParts;


// WEBPACK FOOTER //
// ./src/views/common/ShapeParts.jsx